// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"3e0fa0fd","436":"5770f747","453":"59e206cf","891":"df235b68","947":"73f253c3"}[chunkId] + ".chunk.js";
};